import React, { useContext, useEffect, useState } from "react"
import axios from "axios"
import * as AppConstants from "../../utility/AppConstants"

import PieChart from "../graph/PieChart"
import BarChart from "../graph/BarChart"
import { chartHeight } from "../../utility/Utility"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
import PieChartMultiAnno from "../graph/multiAnno/PieChartMultiAnno"
import { ResponseDatiNazionaliMultiAnno } from "@/utility/model"
import ChartNazionaliMultiAnno from "../graph/multiAnno/ChartNazionaliMultiAnno"

interface SliderGraficiNazionaliProps {
    codIsa: string
    macroarea: string
    anno: string
    datiNazionali: any
}

function SliderGraficiNazionali(props: SliderGraficiNazionaliProps) {
    let codIsa = props.codIsa
    let macroarea = props.macroarea
    let anno = props.anno

    const [dati, setDati] = useState<any[]>([])

    const [multiAnnoState, dispatchMultiAnno] = useContext(MultiAnnoContext)

    useEffect(() => {
        const url = AppConstants.URL_GRAFICO_BARRE
        const config = AppConstants.HEADER_CONFIG
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()

        let id = 0
        if (codIsa !== undefined && codIsa !== null) {
            id = 2
        }

        if (macroarea !== undefined && macroarea !== null) {
            id = 1
        }
        const controller = new AbortController();

        if(!multiAnnoState.isMultiAnno)
        axios
            .get(url, {
                params: {
                    anno: anno,
                    id: id,
                    codIsa: codIsa,
                    macroarea: macroarea,
                    signal: controller.signal
                },
                headers: config
            })
            .then((response) => {
                setDati(response.data)
                //console.log(response.data);
            })
            .catch((err) => {
                //console.log(err);
            })

       // return () => controller.abort();
    }, [codIsa, macroarea, anno])

    return (
        <div className="row">
            <div className="col-2">&nbsp;</div>
            <div className="col-8">
                <div
                    id="custom-slider"
                    className="carousel slide"
                    data-interval="false"
                >
                    <div className="carousel-inner w-auto mx-5">
                        {multiAnnoState.isMultiAnno &&
                        multiAnnoState.totale !== undefined &&
                        multiAnnoState.personeFisiche !== undefined &&
                        
                        multiAnnoState.societaPersone !== undefined &&
                        multiAnnoState.societaCapitalientiNonCommerciali !== undefined ? (
                            <>
                                <div
                                    className="carousel-item active"
                                    aria-hidden="false"
                                >
                                    <ChartNazionaliMultiAnno
                                            title="Numero Posizioni"
                                            dataKey="numPosizioni"
                                            data={props.datiNazionali} anno={Number(anno)}                                    />
                                </div>
                                <div
                                    className="carousel-item"
                                    aria-hidden="false"
                                >
                                    <ChartNazionaliMultiAnno
                                            title="Numero Addetti"
                                            dataKey="numAddetti"
                                            data={props.datiNazionali} anno={Number(anno)}/> 
                                </div>
                                <div
                                    className="carousel-item"
                                    aria-hidden="false"
                                >
                                     <ChartNazionaliMultiAnno
                                            title="Punteggio ISA (Media)"
                                            dataKey="punteggioIsa"
                                            data={props.datiNazionali} anno={Number(anno)}/> 
                                </div>
                                <div
                                    className="carousel-item"
                                    aria-hidden="false"
                                >
                                     <ChartNazionaliMultiAnno
                                            title={AppConstants.DATI_REDDITO_MEDIO}
                                            dataKey="redditoMedio"
                                            data={props.datiNazionali} anno={Number(anno)}/> 
                                </div>
                                <div
                                    className="carousel-item"
                                    aria-hidden="false"
                                >
                                    <ChartNazionaliMultiAnno
                                            title={AppConstants.DATI_ULTERIORI_COMP_POS}
                                            dataKey="adeguamenti"
                                            data={props.datiNazionali} anno={Number(anno)}/> 
                                </div>
                            </>
                        ) : !multiAnnoState.isMultiAnno ? (
                            <div
                                className="carousel-item active"
                                aria-hidden="false"
                            >
                                <PieChart
                                    width={420}
                                    height={600}
                                    innerRadius={0}
                                    outerRadius={180}
                                    data={props.datiNazionali}
                                />
                            </div>
                        ) : null}
                        {!multiAnnoState.isMultiAnno ? (
                            <div className="carousel-item" aria-hidden="false">
                                {dati != null && (
                                    <BarChart
                                        data={dati
                                            .map((graf) => ({
                                                label: graf.range,
                                                value: graf.punteggio
                                            }))
                                            .sort((a, b) =>
                                                a.label.localeCompare(b.label)
                                            )}
                                    />
                                )}
                            </div>
                        ) : null}
                    </div>
                    <a
                        className="carousel-control-prev icon-primary"
                        href="#custom-slider"
                        role="button"
                        data-slide="prev"
                        aria-hidden="true"
                    >
                        <i className="fas fa-chevron-left fa-2x"></i>
                    </a>
                    <a
                        className="carousel-control-next icon-primary"
                        href="#custom-slider"
                        role="button"
                        data-slide="next"
                        aria-hidden="true"
                    >
                        <i className="fas fa-chevron-right fa-2x"></i>
                    </a>
                    <ol className="carousel-indicators" aria-hidden="true">
                        <li
                            data-target="#custom-slider"
                            data-slide-to="0"
                            className="active"
                        ></li>
                        <li data-target="#custom-slider" data-slide-to="1"></li>
                        {multiAnnoState.isMultiAnno ? (
                            <>
                                <li
                                    data-target="#custom-slider"
                                    data-slide-to="2"
                                ></li>
                                <li
                                    data-target="#custom-slider"
                                    data-slide-to="3"
                                ></li>
                                <li
                                    data-target="#custom-slider"
                                    data-slide-to="4"
                                ></li>
                            </>
                        ) : null}
                    </ol>
                </div>
            </div>
            <div className="col-2">&nbsp;</div>
        </div>
    )
}
export default SliderGraficiNazionali
